module.exports = __webpack_public_path__ + "media/images/banner-assets/th/banner3-073e836e43201968352b2704e54539f8.jpg";